<script setup lang="ts">
import StatCard from '@/components/ui/StatCard.vue';
import type { NewThisWeekStat } from '@/api/dashboard-types';

const props = defineProps<{
  stat: NewThisWeekStat | null;
  loading?: boolean;
}>();

function formatDelta(pct: number): string {
  if (pct > 0) return `+${pct}% vs last week`;
  if (pct < 0) return `${pct}% vs last week`;
  return 'same as last week';
}
</script>

<template>
  <div data-testid="new-this-week-stat">
    <StatCard
      label="New this week"
      :value="props.loading || !props.stat ? '—' : props.stat.count"
      :sub="props.stat ? formatDelta(props.stat.deltaPct) : undefined"
    />
  </div>
</template>
